import Vue from 'vue'
import Vuex from 'vuex'
import mutations from './mutations'
import actions from './action'
import getters from './getters'

Vue.use(Vuex);
window.Promise = Promise;
let channel = (() => {
  if ('pgy-back.zhihuipk.com'.indexOf(window.location.hostname) >= 0) {
    return 2
  } else if ('test-pk-ht.hzqisheng.cn'.indexOf(window.location.hostname) >= 0) {
    return 1
  } else {
    return 1
  }

})()
const state = {
  channelId: channel,
  localpath: '',
  houseDialog: false,
  buildSearch: '',
  houseSearch: '',
  costSearch: '',
  finalState: 1,
  houseResId: '',
  housingAddDialog: false,
  costMonth: '',
  feeTypeId: '',
  freeType: '',
  costDetailDialog: false,
  costEdit: {},
  tenantSearch: '',
  adminName: '',
  applyItem: {}
}
export default new Vuex.Store({
  state,
  getters,
  actions,
  mutations,
})



// WEBPACK FOOTER //
// ./src/story/index.js